<form-section [subtitle]="'Additional software'" data-testid="additional-software">
    <form-link [subtitle]="'ImageClip - Program for uploading photographs for the screensaver for controllers'"
                        [value]="'351 kB'"
                        [href]="'/public/download/ImageClip.exe'"
                        [download]="'ImageClip.exe'">
    </form-link>
    <div class="px-16">
        <form-item-text [subtitle]="'The photographs you wish to import to the controller’s memory\n'+
            'first need to be prepared using the graphic program ImageClip.\n'+
            'After installing and launching the program on a PC, load the\n'+
            'selected photograph. Select the photograph’s area that is to \n'+
            'be displayed on the controller. You may rotate the photograph. \n'+
            'After processing the photograph, load another one. Having\n'+
            'prepared all photographs you wish to upload to the controller,\n'+
            'save them on a memory stick in the main folder. Place the memory\n'+
            'stick in the controller’s USB port and launch the option \n'+
            '‘Import Photographs’ from the controller’s menu. You may not \n'+
            'upload more than 8 photographs. When you load new photographs, \n'+
            'the previous ones are automatically removed from the controller’s memory.'">
        </form-item-text>
    </div>
</form-section>
